import { format } from "date-fns";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useQuery } from "urql";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { graphql } from "@/gen";

const tournamentsBySeriesQuery = graphql(`
    query TournamentsBySeries($seriesId: UUID!) {
        tournamentsBySeries(seriesId: $seriesId) {
            id
            title
            startAt
            endAt
        }
    }
`);

export function TournamentSeriesTournamentList({ seriesId }: { seriesId: string }) {
    const [result] = useQuery({
        query: tournamentsBySeriesQuery,
        variables: { seriesId },
        pause: !seriesId,
    });

    if (result.fetching) return <p>Loading tournaments...</p>;
    if (result.error) return <p>Error: {result.error.message}</p>;

    const tournaments = result.data?.tournamentsBySeries || [];

    return (
        <Card className="my-4">
            <CardHeader>
                <CardTitle>Tournaments in this series</CardTitle>
            </CardHeader>
            <CardContent>
                {tournaments.length === 0 ? (
                    <p className="text-muted-foreground">No tournaments added yet.</p>
                ) : (
                    <ul className="divide-y divide-gray-200">
                        {tournaments.map(tournament => (
                            <li key={tournament.id} className="py-2">
                                <Link
                                    to={`/tournaments/${tournament.id}`}
                                    className="flex items-center justify-between rounded p-2 transition-colors hover:bg-gray-200"
                                >
                                    <div>
                                        <p className="font-medium">{tournament.title}</p>
                                        <p className="text-muted-foreground text-sm">
                                            {format(new Date(tournament.startAt), "dd.MM.yyyy")}
                                        </p>
                                    </div>
                                    <ArrowRight size={16} />
                                </Link>
                            </li>
                        ))}
                    </ul>
                )}
            </CardContent>
        </Card>
    );
}
